// extracted by mini-css-extract-plugin
export default {"section":"CA-z","inSectionButton":"DA-z","addressCard":"EA-z","disabled":"FA-z","cautionBox":"GA-z","failureBox":"HA-z","fade-out":"IA-z","successBox":"JA-z"};